import { useEffect } from 'react';
import { usePdfPageSearch } from '../hooks';
import { InputSearch } from '@repo/atomic-components';
import { OutlineIconButton } from '@/ui/components/OutlineIconButton';
import { ExtractMatchingPagesButton } from './ExtractMatchingPagesButton';

export const SearchTextControl = () => {
  const {
    searchInputRef,
    isLoading,
    isSuccess,
    totalSearchResults,
    searchResultPageIds,
    searchResultIndex,
    handlePreviousClick,
    handleNextClick,
    handleResetClick,
    handleSearchInputValueChange,
    handleSearchInputKeyDown,
  } = usePdfPageSearch();

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'f') {
        event.preventDefault();
        if (searchInputRef.current) {
          searchInputRef.current.focus();
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="flex w-full flex-row gap-2">
      {totalSearchResults > 0 && (
        <>
          <div className="flex items-center justify-center text-sm text-nowrap">
            {searchResultIndex + 1} of {totalSearchResults} matches
          </div>
          <div className="border-fletchers-gray-100 flex h-full max-h-[32px] overflow-hidden rounded-[4px] border">
            <OutlineIconButton
              icon="pi pi-arrow-up"
              className="!border-r-fletchers-gray-100 rounded-none! !border-0 !border-r !border-solid"
              onClick={handlePreviousClick}
            />
            <OutlineIconButton icon="pi pi-arrow-down" className="rounded-none! !border-0" onClick={handleNextClick} />
          </div>
          <ExtractMatchingPagesButton pageIds={searchResultPageIds} />
        </>
      )}
      {isSuccess && totalSearchResults === 0 && (
        <>
          <div className="flex items-center justify-center text-sm text-nowrap">No results found</div>
        </>
      )}
      <InputSearch
        ref={searchInputRef}
        type="text"
        placeholder="Search by keyword"
        onChange={handleSearchInputValueChange}
        onKeyDown={handleSearchInputKeyDown}
        onClear={handleResetClick}
        isLoading={isLoading}
      />
    </div>
  );
};
